<template>
  <span>
    <input
      v-if="editing"
      v-model="text"
      type="text"
      class="field-value form-control"
      v-on:blur="updateValue()"
    />
    <router-link v-if="to && !editing" :to=to>{{text}}</router-link>
    <span v-if="!to && !editing">{{text}}</span>
    <span v-show="!editing" v-on:click="startEditing()"
      ><i class="far fa-edit"></i
    ></span>
    <span v-show="editing" v-on:click="updateValue()"
      ><i class="far fa-save"></i
    ></span>
  </span>
</template>
<style>
input {
  color: #444;
}
</style>
<script>
import axios from "axios";

export default {
  name: "editable-text",
  props: ["initialText", "id", "to", "update"],
  watch: {
    initialText(newValue, oldValue) {
      this.text = newValue;
    }
  },
  data() {
    return {
      editing: false,
      text: this.initialText
    }
  },
  methods: {
    startEditing() {
      this.editing = true;
    },
    async updateValue() {
      this.editing = false;
      this.update(this.text);
    }
  }
};
</script>
